import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onAddProperty }) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 md:py-16 lg:py-20 px-4">
      <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-full bg-primary/10 flex items-center justify-center mb-4 md:mb-6">
        <Icon name="Home" size={32} color="var(--color-primary)" className="md:w-10 md:h-10 lg:w-12 lg:h-12" />
      </div>
      <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-2 md:mb-3 text-center">
        No Properties Yet
      </h3>
      <p className="text-sm md:text-base text-muted-foreground mb-6 md:mb-8 text-center max-w-md">
        Start managing your listings by adding your first property. You can track offers, generate reports, and streamline your workflow.
      </p>
      <Button
        variant="default"
        size="lg"
        iconName="Plus"
        iconPosition="left"
        onClick={onAddProperty}
      >
        Add Your First Property
      </Button>
    </div>
  );
};

export default EmptyState;